import React from "react";

// Define working style groups for display
const workingStyleGroups = {
  "In person": ["Fully in-person", "5 days a week in office"],
  "Hybrid": ["Hybrid - 2/3 days in the office", "Hybrid - 3-4 days in the office; 1-2 remote", "Hybrid (1-4 days in office)", "Hybrid (1/2 days in the office) or Fully remote", "Hybrid (2/3 days) or fully in office", "Hybrid or fully in-person"],
  "Remote": ["Fully remote", "Remote or Hybrid", "Remote / Hybrid - on and off months in and out of office depending on travel plans"],
};

// Function to get display name for a working style value
const getWorkingStyleDisplayName = (style) => {
  for (const [displayName, values] of Object.entries(workingStyleGroups)) {
    if (values.includes(style)) {
      return displayName;
    }
  }
  return style; // Default to the original value if not found in groups
};

const ActiveFilters = ({
  filterStream,
  filterYearsOfExp,
  setFilterYearsOfExp,
  filterWorkingStyle,
  filterIndustry,
  searchKeywords,
  onChange,
  clearFilters,
  setSearchKeywords,
  maxSalary,
  setMaxSalary,
}) => {
  // Function to handle removing individual filters, including keywords
  const handleRemoveFilter = (filter) => {
    const updatedFilterStream = filterStream.filter((item) => item !== filter);
    const updatedFilterYearsOfExp = filterYearsOfExp.filter(
      (item) => item !== filter
    );
    const updatedFilterWorkingStyle = filterWorkingStyle.filter(
      (item) => item !== filter
    );
    const updatedFilterIndustry = filterIndustry.filter(
      (item) => item !== filter
    );
    const updatedSearchKeywords = searchKeywords.filter(
      (item) => item !== filter
    );

    onChange({
      filterStream: updatedFilterStream,
      filterYearsOfExp: updatedFilterYearsOfExp,
      filterWorkingStyle: updatedFilterWorkingStyle,
      filterIndustry: updatedFilterIndustry,
      searchKeywords: updatedSearchKeywords,
    });
  };

  // Group working styles by display name
  const groupedWorkingStyles = {};
  
  filterWorkingStyle.forEach(style => {
    const displayName = getWorkingStyleDisplayName(style);
    if (!groupedWorkingStyles[displayName]) {
      groupedWorkingStyles[displayName] = [];
    }
    groupedWorkingStyles[displayName].push(style);
  });

  const HandleRemoveSalary = () => {
    setMaxSalary("");
  };

  const yearsOfExpRange = filterYearsOfExp.length
    ? `${filterYearsOfExp[0].split("-")[0]}-${
        filterYearsOfExp[filterYearsOfExp.length - 1].split("-")[0]
      }`
    : null;

  return (
    <div className="relative pb-10 pr-2">
      <div className="absolute flex col-flex mt-1">
        {searchKeywords.map((filter) => (
          <div
            key={filter}
            className="flex text-sm items-center bg-white rounded-md border border-gray-300 mr-2 pl-4 pr-2"
          >
            {filter}
            <button
              className="ml-2 rounded-md px-2 py-1 text-gray-500 hover:bg-gray-100 cursor-pointer"
              onClick={() => handleRemoveFilter(filter)}
            >
              &#x2715;
            </button>
          </div>
        ))}
        {filterStream.map((filter) => (
          <div
            key={filter}
            className="flex text-sm items-center bg-white rounded-md border border-gray-300 mr-2 pl-4 pr-2"
          >
            {filter}
            <button
              className="ml-2 rounded-md px-2 py-1 text-gray-500 hover:bg-gray-100 cursor-pointer"
              onClick={() => handleRemoveFilter(filter)}
            >
              &#x2715;
            </button>
          </div>
        ))}

        {/* Display working style filters grouped by display name */}
        {Object.keys(groupedWorkingStyles).map((displayName) => (
          <div
            key={displayName}
            className="flex text-sm items-center bg-white rounded-md border border-gray-300 mr-2 py-2 pl-4 pr-2"
          >
            {displayName}
            <button
              className="ml-2 rounded-md px-2 py-1 text-gray-500 hover:bg-gray-100 cursor-pointer"
              onClick={() => {
                // Remove all working styles in this display group
                const allValuesInGroup = workingStyleGroups[displayName] || [displayName];
                const updatedStyles = filterWorkingStyle.filter(
                  style => !allValuesInGroup.includes(style)
                );
                onChange({
                  filterStream,
                  filterYearsOfExp,
                  filterWorkingStyle: updatedStyles,
                  filterIndustry,
                  searchKeywords,
                });
              }}
            >
              &#x2715;
            </button>
          </div>
        ))}

        {filterIndustry.map((filter) => (
          <div
            key={filter}
            className="flex text-sm items-center bg-white rounded-md border border-gray-300 mr-2 py-2 pl-4 pr-2"
          >
            {filter}
            <button
              className="ml-2 rounded-md px-2 py-1 text-gray-500 hover:bg-gray-100 cursor-pointer"
              onClick={() => handleRemoveFilter(filter)}
            >
              &#x2715;
            </button>
          </div>
        ))}

        {yearsOfExpRange && (
          <div className="flex text-sm items-center bg-white rounded-md border border-gray-300 mr-2 py-2 pl-4 pr-2">
            Years of Exp: {yearsOfExpRange}
            <button
              className="ml-2 rounded-md px-2 py-1 text-gray-500 hover:bg-gray-100 cursor-pointer"
              onClick={() => setFilterYearsOfExp([])}
            >
              &#x2715;
            </button>
          </div>
        )}

        {maxSalary && (
          <div className="flex text-sm items-center bg-white rounded-md border border-gray-300 mr-2 py-2 pl-4 pr-2">
            Max salary: £{maxSalary}
            {maxSalary !== "50k+" && "k"}
            <button
              onClick={() => HandleRemoveSalary()}
              className="ml-2 rounded-md px-2 py-1 text-gray-500 hover:bg-gray-100 cursor-pointer"
            >
              &#x2715;
            </button>
          </div>
        )}

        {searchKeywords.length > 0 ||
        filterStream.length > 0 ||
        filterIndustry.length > 0 ||
        filterWorkingStyle.length > 0 ||
        maxSalary ||
        filterYearsOfExp.length > 0 ||
        filterYearsOfExp.length > 0 ? (
          <button
            onClick={(e) => {
              e.stopPropagation();
              clearFilters(); // Ensure clearFilters empties the searchKeywords as well
            }}
            type="button"
            className="py-2.5 px-5 text-sm font-medium text-gray-900 bg-white hover:bg-gray-200 rounded-lg hover:text-gray-700"
          >
            Clear filters
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default ActiveFilters;
